module.exports = __webpack_public_path__ + "media/监控02.9a73eb6e.mp4";